<template>
  <!-- <div style="width: 100%;height: 100%;"> -->
  <div style="width: 100%;height: calc(100% - 60px);" id="boxW">
    <canvas :width="width" :height="width" id="canvas"></canvas>
  </div>
</template>

<script>
const padding = 25;
export default {
  props: {
    width: {
      type: Number,
      default: 400
    }
  },
  data(){
      return{
      }
      
  },
  mounted() {
    const arcWidth = this.width - padding * 2 - 50;
    const middle = arcWidth / 2 + padding + 25;
    const x1 = arcWidth / 4 + padding,
      x2 = (arcWidth / 4) * 3 + padding + 50,
      x3 = this.width - padding;
    const y1 = arcWidth / 4 + padding,
      y2 = (arcWidth / 4) * 3 + padding + 50,
      y3 = this.width - padding;
    var canvas = document.getElementById("canvas"); //找到 <canvas> 元素:
    var ctx = canvas.getContext("2d"); //创建context对象
    ctx.beginPath(); //标志开始一个路径
    ctx.arc(middle, middle, arcWidth / 2, 0, 2 * Math.PI); //在canvas中绘制圆形
    // 设置线宽
    ctx.lineWidth = 2;
    // 设置间距（参数为无限数组，虚线的样式会随数组循环）
    ctx.setLineDash([4, 4]);
    // 填充颜色
    ctx.strokeStyle = "#ccc";
    // 开始填充
    ctx.stroke();
    ctx.beginPath();

    ctx.arc(middle, middle, arcWidth / 4, 0, 2 * Math.PI); //在canvas中绘制圆形
    // 设置线宽
    ctx.lineWidth = 2;
    // 设置间距（参数为无限数组，虚线的样式会随数组循环）
    ctx.setLineDash([4, 4]);
    // 填充颜色
    ctx.strokeStyle = "#ccc";
    // 开始填充
    ctx.stroke();
    ctx.beginPath();

    //中间线
    ctx.moveTo(middle, padding);
    ctx.lineTo(middle, y3);
    ctx.moveTo(padding, middle);
    ctx.lineTo(x3, middle);

    ctx.moveTo(x1, padding);
    ctx.lineTo(x2, y3);
    ctx.moveTo(padding, y1);
    ctx.lineTo(x3, y2);

    ctx.moveTo(x2, padding);
    ctx.lineTo(x1, y3);

    ctx.moveTo(x3, y1);
    ctx.lineTo(padding, y2);
    ctx.stroke();

    // 设置字体
    ctx.font = "14px bold 黑体";
    // 设置颜色
    ctx.fillStyle = "#000";
    // 设置水平对齐方式
    ctx.textAlign = "center";
    // 设置垂直对齐方式
    ctx.textBaseline = "middle";
    // 绘制文字（参数：要写的字，x坐标，y坐标）
    ctx.fillText("90°", middle, 15);
    ctx.fillText("270°", middle, this.width - 15);
    ctx.fillText("0°", this.width - 15, middle);
    ctx.fillText("180°", 15, middle);
    ctx.beginPath();
    ctx.setLineDash([]);
    // this.draw(30, 100, "#000");
    // this.draw(60, 50, "red");
  },
  methods: {
    drawArrow(ctx, beginPoint, stopPoint, color) {
      let polygonVertex = [],
        CONST = {
          edgeLen: 40,
          angle: 16
        };
      let angle = "";
      polygonVertex[0] = beginPoint.x;
      polygonVertex[1] = beginPoint.y;
      polygonVertex[6] = stopPoint.x;
      polygonVertex[7] = stopPoint.y;

      angle =
        (Math.atan2(stopPoint.y - beginPoint.y, stopPoint.x - beginPoint.x) /
          Math.PI) *
        180;
      var x = stopPoint.x - beginPoint.x,
        y = stopPoint.y - beginPoint.y,
        length = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
      if (length < 250) {
        CONST.edgeLen = CONST.edgeLen / 2;
        CONST.angle = CONST.angle / 2;
      } else if (length < 500) {
        CONST.edgeLen = (CONST.edgeLen * length) / 500;
        CONST.angle = (CONST.angle * length) / 500;
      }

      polygonVertex[8] =
        stopPoint.x -
        CONST.edgeLen * Math.cos((Math.PI / 180) * (angle + CONST.angle));
      polygonVertex[9] =
        stopPoint.y -
        CONST.edgeLen * Math.sin((Math.PI / 180) * (angle + CONST.angle));
      polygonVertex[4] =
        stopPoint.x -
        CONST.edgeLen * Math.cos((Math.PI / 180) * (angle - CONST.angle));
      polygonVertex[5] =
        stopPoint.y -
        CONST.edgeLen * Math.sin((Math.PI / 180) * (angle - CONST.angle));

      var midpoint = {};
      midpoint.x = (polygonVertex[4] + polygonVertex[8]) / 2;
      midpoint.y = (polygonVertex[5] + polygonVertex[9]) / 2;
      polygonVertex[2] = (polygonVertex[4] + midpoint.x) / 2;
      polygonVertex[3] = (polygonVertex[5] + midpoint.y) / 2;
      polygonVertex[10] = (polygonVertex[8] + midpoint.x) / 2;
      polygonVertex[11] = (polygonVertex[9] + midpoint.y) / 2;

      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.moveTo(polygonVertex[0], polygonVertex[1]);
      ctx.lineTo(polygonVertex[2], polygonVertex[3]);
      ctx.lineTo(polygonVertex[4], polygonVertex[5]);
      ctx.lineTo(polygonVertex[6], polygonVertex[7]);
      ctx.lineTo(polygonVertex[8], polygonVertex[9]);
      ctx.lineTo(polygonVertex[10], polygonVertex[11]);
      // ctx.lineTo(polygonVertex[0], polygonVertex[1]);
      ctx.closePath();
      ctx.fill();
    },
    //angle相角  length有效值
    draw(angle, length, color) {
       if(angle==''||length==''){
           return
       }
        var canvas = document.getElementById("canvas"); //找到 <canvas> 元素:
        var ctx = canvas.getContext("2d"); //创建context对象
        const arcWidth = this.width - padding * 2 - 50;
        const middle = arcWidth / 2 + padding + 25;
        var radian = ((2 * Math.PI) / 360) * (90 - angle);
        // return {
        let x = Math.sin(radian) * length; //邻边
        let y = Math.cos(radian) * length; //对边
        // };
        x = middle + x;
        y = middle - y;
        this.drawArrow(ctx, { x: middle, y: middle }, { x: x, y: y }, color);
    }
  }
};
</script>